// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9f-4";
export var collapsed = "_9f-1";
export var headerBar = "_9f-0";
export var leftHeaderContent = "_9f-3";
export var subjectContainer = "_9f-2";